export type Lang = "de" | "fr" | "it" | "en" | "sq";

export const translations: Record<Lang, Record<string, string>> = {
  de: {
    // Navbar
    nav_services: "Leistungen",
    nav_capacity: "Kennzahlen",
    nav_map: "Netzwerk",
    nav_technology: "Technologie",
    nav_contact: "Kontakt",
    nav_cta: "Angebot anfragen",
    navbar_since: "Seit 2005 · Schweiz",
    navbar_tagline: "Transport · Montage · Showroom",

    // Hero
    hero_badge: "Professionelle Lösung · DS Logistik Schweiz",
    hero_title1: "Möbeltransport & Montage —",
    hero_title2: "industrieller Standard",
    hero_title3: ", premium Ergebnis.",
    hero_desc: "DS Logistik bietet vollständige operative Lösungen für Möbeltransport, Küchenmontage, Zügeln & Umzüge, Showroom-Betrieb und Partner-Logistik — mit 350+ Mitarbeitenden, 150 Fahrzeugen, 58+ Verteilungspunkten und 250.000 Kunden pro Jahr.",
    hero_btn_contact: "Jetzt Kontakt aufnehmen",
    hero_btn_services: "Leistungen ansehen",
    stats_label: "Operational Scale",
    stat_mitarbeiter: "Mitarbeitende",
    stat_fahrzeuge: "Fahrzeuge 3,5 t",
    stat_kunden: "Kunden / Jahr",
    stat_partner: "Aktive Partner",
    stat_punkte: "Verteilpunkte CH",

    // Video section
    video_badge: "DS Logistik · Fuhrpark in Aktion",
    video_title: "150 Fahrzeuge. Täglich im Einsatz. Überall in der Schweiz.",

    // Stats banner
    stats_badge: "Unternehmen im industriellen Massstab",
    stats_title: "Grosse Kapazität. Kontrollierte Ausführung.",
    stats_subtitle: "Die Zahlen sprechen für sich: DS Logistik ist strukturiert, um das hohe Volumen der Retail-Partner das ganze Jahr über mit konstanten Betriebsstandards zu bewältigen.",

    // Map
    map_badge: "Flächendeckend in der ganzen Schweiz",
    map_title: "58+ Verteilungspunkte. Jeder Kanton. Jede Region.",
    map_desc: "Von Genf bis St. Gallen, von Basel bis Lugano — das DS Logistik Netzwerk deckt die gesamte Schweiz ab mit schnellen Lieferzeiten und regionalem Service in allen 26 Kantonen.",
    map_legend: "DS Logistik Verteilungspunkt",
    map_standorte: "Standorte",
    map_kantone: "Kantone",
    map_lieferzeit: "Lieferzeit",

    // Services section
    services_badge: "Unser Leistungsangebot",
    services_title: "Vom Lager zum Endkunden — vollständige operative Lösung.",
    services_desc: "DS Logistik kombiniert Fuhrpark, Montageteams und Vor-Ort-Koordination, um ein vollständiges Erlebnis zu bieten — von der Auftragsannahme bis zur abgeschlossenen Lieferung.",
    services_coverage: "58+ Verteilungspunkte in der ganzen Schweiz",
    services_coverage_text: "Flächendeckende Präsenz in allen Kantonen — für schnelle und zuverlässige Lieferung in der gesamten Schweiz.",
    svc_transport: "Möbeltransport",
    svc_transport_text: "Vollständige Abwicklung von Lieferungen für Möbel, Küchen und sperrige Waren — mit präziser Planung und hoher täglicher Kapazität.",
    svc_montage: "Professionelle Montage",
    svc_montage_text: "Möbel- und Küchenmontage durch spezialisierte Teams — mit Fokus auf Qualität, Termintreue und optimale Kundenerfahrung.",
    svc_showroom: "Showroom-Service",
    svc_showroom_text: "Bestückung, Installation, Umzug und Auffrischung von Showroom-Umgebungen für Retail-Partner und Ausstellungspunkte.",
    svc_logistik: "Operative Logistik",
    svc_logistik_text: "Koordination des gesamten Flusses vom Lager bis zum Endkunden — mit strukturierten Prozessen und vollständiger Transparenz.",
    svc_zuegel: "Zügeln / Umzüge",
    svc_zuegel_text: "Professionelle Umzugsdienstleistungen für Privat- und Geschäftskunden — sorgfältig, pünktlich und mit vollem Versicherungsschutz.",
    svc_entsorgung: "Entsorgung",
    svc_entsorgung_text: "Fachgerechte Entsorgung von Altmöbeln, Küchen und Haushaltsgegenständen — umweltgerecht, schnell und auf Wunsch direkt nach der Lieferung oder Montage.",
    svc_elektro: "Elektro- & Haushaltsgeräte",
    svc_elektro_text: "Professioneller Transport und fachgerechte Installation aller Haushaltsgeräte und weisser Ware — Kühlschränke, Waschmaschinen, Geschirrspüler, Herde und mehr — direkt beim Kunden, inklusive Anschluss und Inbetriebnahme.",
    svc_flexschutz: "Fleckenschutz®",
    svc_flexschutz_text: "Professioneller Schutz für Ihre neuen Polstermöbel — Imprägnierung gegen Flecken, Kaffee, Wasser und Schmutz. 3 Jahre Schutzgarantie. Mehr erfahren →",

    // Advantages
    adv_badge: "Warum DS Logistik",
    adv_title: "Struktur für Leistung, Verlässlichkeit und Vertrauen.",
    adv1_title: "Zuverlässigkeit im industriellen Massstab",
    adv1_text: "Operative Struktur, die hohes tägliches Volumen ohne Kompromisse bei Qualität oder Termintreue bewältigt.",
    adv2_title: "Schnelligkeit und präzise Koordination",
    adv2_text: "Klare Planung von Routen, Teams und Installationszeitfenstern für eine möglichst effiziente Ausführung.",
    adv3_title: "Langfristige Partnerschaft",
    adv3_text: "Geschäftsmodell aufgebaut für Retailer und Showrooms, die einen konstanten Standard und gemeinsames Wachstum anstreben.",
    process_badge: "Arbeitsablauf",
    process1_title: "Koordination",
    process1_text: "Auftragsplanung und detaillierte Abstimmung mit dem Partner.",
    process2_title: "Transport",
    process2_text: "Sicherer und überwachter Transport mit dem DS Logistik Fuhrpark.",
    process3_title: "Montage",
    process3_text: "Professionelle Montage an der Kundenadresse oder im Showroom.",
    process4_title: "Übergabe",
    process4_text: "Abschlusskontrolle der Qualität und Bestätigung der Lieferung.",
    partner_badge: "Partnerprofil",
    partner_title: "Geeignet für Retail, Showrooms und Vertriebsnetzwerke.",

    // Urbantz
    tech_badge: "Technologie-Partner",
    tech_title: "Optimiert mit Urbantz",
    tech_desc: "DS Logistik nutzt Urbantz — die führende Last-Mile-Delivery-Plattform — für alle Routenoptimierungen, Echtzeit-Tracking und dynamische Lieferplanung. Jeder Fahrer, jede Route, jede Lieferung — digital gesteuert und optimiert.",
    tech_route: "Routenoptimierung",
    tech_route_text: "Intelligente Planung aller 150 Fahrzeuge täglich",
    tech_track: "Echtzeit-Tracking",
    tech_track_text: "Live-Standort jedes Fahrers und jeder Lieferung",
    tech_48h: "48h Lieferzeit",
    tech_48h_text: "Präzise Zeitfenster und automatische Kunden-SMS",
    tech_epod: "ePOD & Nachweis",
    tech_epod_text: "Digitale Lieferbestätigung mit Foto und Signatur",

    // Contact
    contact_badge: "Kontakt & Nächster Schritt",
    contact_title: "Bereit für operative Partnerschaften? Sprechen wir.",
    contact_desc: "Kontaktieren Sie uns direkt — per Telefon, E-Mail oder füllen Sie das Anfrageformular aus. Wir melden uns innerhalb von 24 Stunden.",
    form_services_label: "Dienstleistungen auswählen:",
    form_name: "Ihr Name *",
    form_email: "Ihre E-Mail *",
    form_phone: "Telefonnummer (optional)",
    form_message: "Weitere Informationen zu Ihrer Anfrage…",
    form_submit: "Anfrage absenden",
    contact_phone_label: "Telefon",
    contact_addr_label: "Adresse",
    contact_b2b_label: "B2B-Partnerschaften",
    contact_b2b_text: "Ideal für Retail-Unternehmen, Distributoren und Showroom-Netzwerke, die einen professionellen Logistikpartner suchen.",
    contact_b2c_label: "B2C-Privatkunden",
    contact_b2c_text: "Privatpersonen, die Möbel transportieren, montieren, umziehen oder entsorgen möchten — professionell, zuverlässig und zu fairen Preisen.",
    form_no_selection: "Keine Auswahl",
    form_subject_prefix: "Serviceanfrage:",
    form_body_name: "Name",
    form_body_email: "E-Mail",
    form_body_phone: "Telefon",
    form_body_services: "Dienstleistungen",
    form_body_message: "Nachricht",
    form_body_sent: "Gesendet via DS Logistik Website",
    // address is hardcoded in Index.tsx contact card

    // Footer
    footer_copy: "Transport · Montage · Showroom",
    footer_since: "Schweiz · Seit 2005",
  },

  fr: {
    nav_services: "Services",
    nav_capacity: "Chiffres clés",
    nav_map: "Réseau",
    nav_technology: "Technologie",
    nav_contact: "Contact",
    nav_cta: "Demande",
    navbar_since: "Depuis 2005 · Suisse",
    navbar_tagline: "Transport · Montage · Showroom",

    hero_badge: "Solution professionnelle · DS Logistik Suisse",
    hero_title1: "Transport & Montage de meubles —",
    hero_title2: "standard industriel",
    hero_title3: ", résultat premium.",
    hero_desc: "DS Logistik offre des solutions logistiques complètes pour le transport de meubles, la montage de cuisines, les déménagements, la gestion de showrooms et la logistique partenaires — avec 350+ collaborateurs, 150 véhicules, 58+ points de distribution et 250 000 clients par an.",
    hero_btn_contact: "Nous contacter",
    hero_btn_services: "Voir les services",
    stats_label: "Capacité opérationnelle",
    stat_mitarbeiter: "Collaborateurs",
    stat_fahrzeuge: "Véhicules 3,5 t",
    stat_kunden: "Clients / An",
    stat_partner: "Partenaires actifs",
    stat_punkte: "Points CH",

    video_badge: "DS Logistik · Flotte en action",
    video_title: "150 véhicules. En action chaque jour. Partout en Suisse.",

    stats_badge: "Entreprise à l'échelle industrielle",
    stats_title: "Grande capacité. Exécution contrôlée.",
    stats_subtitle: "Les chiffres parlent d'eux-mêmes : DS Logistik est structuré pour gérer le volume élevé des partenaires retail tout au long de l'année avec des standards opérationnels constants.",

    map_badge: "Couvrant toute la Suisse",
    map_title: "58+ points de distribution. Chaque canton. Chaque région.",
    map_desc: "De Genève à Saint-Gall, de Bâle à Lugano — le réseau DS Logistik couvre toute la Suisse avec des délais de livraison rapides dans les 26 cantons.",
    map_legend: "Point de distribution DS Logistik",
    map_standorte: "Sites",
    map_kantone: "Cantons",
    map_lieferzeit: "Délai livraison",

    services_badge: "Notre offre de services",
    services_title: "De l'entrepôt au client final — solution opérationnelle complète.",
    services_desc: "DS Logistik combine flotte, équipes de montage et coordination sur site pour offrir une expérience complète — de la prise de commande à la livraison terminée.",
    services_coverage: "58+ points de distribution en Suisse",
    services_coverage_text: "Présence nationale dans tous les cantons — pour une livraison rapide et fiable dans toute la Suisse.",
    svc_transport: "Transport de meubles",
    svc_transport_text: "Traitement complet des livraisons de meubles, cuisines et marchandises volumineuses — avec une planification précise et une grande capacité quotidienne.",
    svc_montage: "Montage professionnel",
    svc_montage_text: "Montage de meubles et de cuisines par des équipes spécialisées — avec un accent sur la qualité, le respect des délais et l'expérience client optimale.",
    svc_showroom: "Service Showroom",
    svc_showroom_text: "Approvisionnement, installation, déménagement et rafraîchissement des environnements showroom pour les partenaires retail.",
    svc_logistik: "Logistique opérationnelle",
    svc_logistik_text: "Coordination de l'ensemble du flux de l'entrepôt au client final — avec des processus structurés et une transparence totale.",
    svc_zuegel: "Déménagements",
    svc_zuegel_text: "Services de déménagement professionnels pour particuliers et entreprises — soigneux, ponctuels et avec couverture d'assurance complète.",
    svc_entsorgung: "Élimination",
    svc_entsorgung_text: "Élimination professionnelle de vieux meubles, cuisines et objets ménagers — respectueuse de l'environnement, rapide et sur demande directement après la livraison.",
    svc_elektro: "Électroménager & Appareils",
    svc_elektro_text: "Transport professionnel et installation experte de tous les appareils électroménagers — réfrigérateurs, machines à laver, lave-vaisselle, cuisinières — raccordement et mise en service inclus.",
    svc_flexschutz: "Fleckenschutz®",
    svc_flexschutz_text: "Protection professionnelle pour vos nouveaux canapés — imperméabilisation contre les taches, café, eau et saleté. 3 ans de garantie. En savoir plus →",

    adv_badge: "Pourquoi DS Logistik",
    adv_title: "Structure pour la performance, la fiabilité et la confiance.",
    adv1_title: "Fiabilité à l'échelle industrielle",
    adv1_text: "Structure opérationnelle qui gère un volume quotidien élevé sans compromettre la qualité ou le respect des délais.",
    adv2_title: "Rapidité et coordination précise",
    adv2_text: "Planification claire des routes, des équipes et des créneaux d'installation pour une exécution aussi efficace que possible.",
    adv3_title: "Partenariat à long terme",
    adv3_text: "Modèle commercial conçu pour les retailers et showrooms qui recherchent un standard constant et une croissance commune.",
    process_badge: "Flux de travail",
    process1_title: "Coordination",
    process1_text: "Planification des commandes et coordination détaillée avec le partenaire.",
    process2_title: "Transport",
    process2_text: "Transport sécurisé et supervisé avec la flotte DS Logistik.",
    process3_title: "Montage",
    process3_text: "Montage professionnel à l'adresse du client ou dans le showroom.",
    process4_title: "Remise",
    process4_text: "Contrôle final de la qualité et confirmation de la livraison.",
    partner_badge: "Profil partenaire",
    partner_title: "Adapté au retail, showrooms et réseaux de distribution.",

    tech_badge: "Partenaire technologique",
    tech_title: "Optimisé avec Urbantz",
    tech_desc: "DS Logistik utilise Urbantz — la plateforme leader du last mile — pour toutes les optimisations de routes, le suivi en temps réel et la planification dynamique des livraisons. Chaque chauffeur, chaque route, chaque livraison — géré et optimisé numériquement.",
    tech_route: "Optimisation des routes",
    tech_route_text: "Planification intelligente des 150 véhicules quotidiennement",
    tech_track: "Suivi en temps réel",
    tech_track_text: "Position en direct de chaque chauffeur et livraison",
    tech_48h: "Livraison 48h",
    tech_48h_text: "Créneaux précis et SMS automatiques aux clients",
    tech_epod: "ePOD & Preuve",
    tech_epod_text: "Confirmation de livraison digitale avec photo et signature",

    contact_badge: "Contact & Prochaine étape",
    contact_title: "Prêt pour des partenariats opérationnels ? Parlons-en.",
    contact_desc: "Contactez-nous directement — par téléphone, e-mail ou remplissez le formulaire. Nous vous répondons dans les 24 heures.",
    form_services_label: "Sélectionner les services :",
    form_name: "Votre nom *",
    form_email: "Votre e-mail *",
    form_phone: "Numéro de téléphone (optionnel)",
    form_message: "Informations supplémentaires sur votre demande…",
    form_submit: "Envoyer la demande",
    contact_phone_label: "Téléphone",
    contact_addr_label: "Adresse",
    contact_b2b_label: "Partenariats B2B",
    contact_b2b_text: "Idéal pour les entreprises de retail, distributeurs et réseaux de showrooms cherchant un partenaire logistique professionnel.",
    contact_b2c_label: "B2C-Clients privés",
    contact_b2c_text: "Particuliers souhaitant transporter, assembler, déménager ou éliminer des meubles — de manière professionnelle, fiable et à des prix équitables.",
    form_no_selection: "Aucune sélection",
    form_subject_prefix: "Demande de service :",
    form_body_name: "Nom",
    form_body_email: "E-Mail",
    form_body_phone: "Téléphone",
    form_body_services: "Services",
    form_body_message: "Message",
    form_body_sent: "Envoyé via le site DS Logistik",

    footer_copy: "Transport · Montage · Showroom",
    footer_since: "Suisse · Depuis 2005",
  },

  it: {
    nav_services: "Servizi",
    nav_capacity: "Cifre chiave",
    nav_map: "Rete",
    nav_technology: "Tecnologia",
    nav_contact: "Contatto",
    nav_cta: "Richiesta",
    navbar_since: "Dal 2005 · Svizzera",
    navbar_tagline: "Trasporto · Montaggio · Showroom",

    hero_badge: "Soluzione professionale · DS Logistik Svizzera",
    hero_title1: "Trasporto & Montaggio mobili —",
    hero_title2: "standard industriale",
    hero_title3: ", risultato premium.",
    hero_desc: "DS Logistik offre soluzioni logistiche complete per il trasporto di mobili, montaggio cucine, traslochi, gestione showroom e logistica partner — con 350+ collaboratori, 150 veicoli, 58+ punti di distribuzione e 250.000 clienti all'anno.",
    hero_btn_contact: "Contattaci ora",
    hero_btn_services: "Vedi i servizi",
    stats_label: "Capacità operativa",
    stat_mitarbeiter: "Collaboratori",
    stat_fahrzeuge: "Veicoli 3,5 t",
    stat_kunden: "Clienti / Anno",
    stat_partner: "Partner attivi",
    stat_punkte: "Punti CH",

    video_badge: "DS Logistik · Flotta in azione",
    video_title: "150 veicoli. In azione ogni giorno. In tutta la Svizzera.",

    stats_badge: "Azienda su scala industriale",
    stats_title: "Grande capacità. Esecuzione controllata.",
    stats_subtitle: "I numeri parlano da soli: DS Logistik è strutturata per gestire l'elevato volume dei partner retail tutto l'anno con standard operativi costanti.",

    map_badge: "Copertura in tutta la Svizzera",
    map_title: "58+ punti di distribuzione. Ogni cantone. Ogni regione.",
    map_desc: "Da Ginevra a San Gallo, da Basilea a Lugano — la rete DS Logistik copre tutta la Svizzera con tempi di consegna rapidi in tutti i 26 cantoni.",
    map_legend: "Punto di distribuzione DS Logistik",
    map_standorte: "Sedi",
    map_kantone: "Cantoni",
    map_lieferzeit: "Tempi consegna",

    services_badge: "La nostra offerta di servizi",
    services_title: "Dal magazzino al cliente finale — soluzione operativa completa.",
    services_desc: "DS Logistik combina flotta, team di montaggio e coordinamento in loco per offrire un'esperienza completa — dalla presa in carico all'ordine consegnato.",
    services_coverage: "58+ punti di distribuzione in tutta la Svizzera",
    services_coverage_text: "Presenza capillare in tutti i cantoni — per consegne rapide e affidabili in tutta la Svizzera.",
    svc_transport: "Trasporto mobili",
    svc_transport_text: "Gestione completa delle consegne di mobili, cucine e merci voluminose — con pianificazione precisa e alta capacità giornaliera.",
    svc_montage: "Montaggio professionale",
    svc_montage_text: "Montaggio di mobili e cucine da parte di team specializzati — con focus su qualità, rispetto dei tempi e ottima esperienza cliente.",
    svc_showroom: "Servizio Showroom",
    svc_showroom_text: "Allestimento, installazione, trasloco e aggiornamento degli ambienti showroom per partner retail.",
    svc_logistik: "Logistica operativa",
    svc_logistik_text: "Coordinamento dell'intero flusso dal magazzino al cliente finale — con processi strutturati e piena trasparenza.",
    svc_zuegel: "Traslochi",
    svc_zuegel_text: "Servizi di trasloco professionali per privati e aziende — attenti, puntuali e con copertura assicurativa completa.",
    svc_entsorgung: "Smaltimento",
    svc_entsorgung_text: "Smaltimento professionale di vecchi mobili, cucine e oggetti domestici — ecologico, rapido e su richiesta direttamente dopo la consegna.",
    svc_elektro: "Elettrodomestici & Grandi Bianchi",
    svc_elektro_text: "Trasporto professionale e installazione di tutti gli elettrodomestici — frigoriferi, lavatrici, lavastoviglie, cucine — allacciamento e messa in funzione inclusi.",
    svc_flexschutz: "Fleckenschutz®",
    svc_flexschutz_text: "Protezione professionale per i vostri nuovi divani — impermeabilizzazione contro macchie, caffè, acqua e sporco. 3 anni di garanzia. Scopri di più →",

    adv_badge: "Perché DS Logistik",
    adv_title: "Struttura per performance, affidabilità e fiducia.",
    adv1_title: "Affidabilità su scala industriale",
    adv1_text: "Struttura operativa che gestisce un volume giornaliero elevato senza compromettere qualità o rispetto dei tempi.",
    adv2_title: "Rapidità e coordinamento preciso",
    adv2_text: "Pianificazione chiara di percorsi, team e finestre di installazione per un'esecuzione il più efficiente possibile.",
    adv3_title: "Partnership a lungo termine",
    adv3_text: "Modello di business costruito per retailer e showroom che cercano uno standard costante e una crescita comune.",
    process_badge: "Flusso di lavoro",
    process1_title: "Coordinamento",
    process1_text: "Pianificazione degli ordini e coordinamento dettagliato con il partner.",
    process2_title: "Trasporto",
    process2_text: "Trasporto sicuro e supervisionato con la flotta DS Logistik.",
    process3_title: "Montaggio",
    process3_text: "Montaggio professionale all'indirizzo del cliente o nello showroom.",
    process4_title: "Consegna",
    process4_text: "Controllo finale della qualità e conferma della consegna.",
    partner_badge: "Profilo partner",
    partner_title: "Adatto a retail, showroom e reti di distribuzione.",

    tech_badge: "Partner tecnologico",
    tech_title: "Ottimizzato con Urbantz",
    tech_desc: "DS Logistik utilizza Urbantz — la piattaforma leader del last mile — per tutte le ottimizzazioni di percorso, il tracciamento in tempo reale e la pianificazione dinamica delle consegne. Ogni autista, ogni percorso, ogni consegna — gestito e ottimizzato digitalmente.",
    tech_route: "Ottimizzazione percorsi",
    tech_route_text: "Pianificazione intelligente di tutti i 150 veicoli ogni giorno",
    tech_track: "Tracciamento in tempo reale",
    tech_track_text: "Posizione live di ogni autista e consegna",
    tech_48h: "Consegna 48h",
    tech_48h_text: "Finestre temporali precise e SMS automatici ai clienti",
    tech_epod: "ePOD & Prova",
    tech_epod_text: "Conferma di consegna digitale con foto e firma",

    contact_badge: "Contatto & Prossimo passo",
    contact_title: "Pronti per partnership operative? Parliamone.",
    contact_desc: "Contattateci direttamente — per telefono, e-mail o compilate il modulo. Vi risponderemo entro 24 ore.",
    form_services_label: "Seleziona i servizi:",
    form_name: "Il tuo nome *",
    form_email: "La tua e-mail *",
    form_phone: "Numero di telefono (opzionale)",
    form_message: "Ulteriori informazioni sulla tua richiesta…",
    form_submit: "Invia richiesta",
    contact_phone_label: "Telefono",
    contact_addr_label: "Indirizzo",
    contact_b2b_label: "Partnership B2B",
    contact_b2b_text: "Ideale per aziende retail, distributori e reti di showroom alla ricerca di un partner logistico professionale.",
    contact_b2c_label: "B2C-Clienti privati",
    contact_b2c_text: "Privati che desiderano trasportare, montare, traslocare o smaltire mobili — in modo professionale, affidabile e a prezzi equi.",
    form_no_selection: "Nessuna selezione",
    form_subject_prefix: "Richiesta servizio:",
    form_body_name: "Nome",
    form_body_email: "E-Mail",
    form_body_phone: "Telefono",
    form_body_services: "Servizi",
    form_body_message: "Messaggio",
    form_body_sent: "Inviato tramite il sito DS Logistik",

    footer_copy: "Trasporto · Montaggio · Showroom",
    footer_since: "Svizzera · Dal 2005",
  },

  en: {
    nav_services: "Services",
    nav_capacity: "Key Figures",
    nav_map: "Network",
    nav_technology: "Technology",
    nav_contact: "Contact",
    nav_cta: "Get a Quote",
    navbar_since: "Since 2005 · Switzerland",
    navbar_tagline: "Transport · Assembly · Showroom",

    hero_badge: "Professional Solution · DS Logistik Switzerland",
    hero_title1: "Furniture Transport & Assembly —",
    hero_title2: "industrial standard",
    hero_title3: ", premium results.",
    hero_desc: "DS Logistik provides complete operational solutions for furniture transport, kitchen assembly, relocations, showroom management and partner logistics — with 350+ employees, 150 vehicles, 58+ distribution points and 250,000 customers per year.",
    hero_btn_contact: "Contact us now",
    hero_btn_services: "View services",
    stats_label: "Operational Scale",
    stat_mitarbeiter: "Employees",
    stat_fahrzeuge: "Vehicles 3.5 t",
    stat_kunden: "Customers / Year",
    stat_partner: "Active Partners",
    stat_punkte: "Distribution Points",

    video_badge: "DS Logistik · Fleet in Action",
    video_title: "150 vehicles. In action every day. Across Switzerland.",

    stats_badge: "Company at industrial scale",
    stats_title: "Large capacity. Controlled execution.",
    stats_subtitle: "The numbers speak for themselves: DS Logistik is structured to handle the high volume of retail partners year-round with consistent operational standards.",

    map_badge: "Nationwide Coverage in Switzerland",
    map_title: "58+ Distribution Points. Every Canton. Every Region.",
    map_desc: "From Geneva to St. Gallen, from Basel to Lugano — the DS Logistik network covers all of Switzerland with fast delivery times across all 26 cantons.",
    map_legend: "DS Logistik Distribution Point",
    map_standorte: "Locations",
    map_kantone: "Cantons",
    map_lieferzeit: "Delivery time",

    services_badge: "Our service offering",
    services_title: "From warehouse to end customer — complete operational solution.",
    services_desc: "DS Logistik combines fleet, assembly teams and on-site coordination to deliver a complete experience — from order intake to completed delivery.",
    services_coverage: "58+ distribution points across Switzerland",
    services_coverage_text: "Nationwide presence in all cantons — for fast and reliable delivery throughout Switzerland.",
    svc_transport: "Furniture Transport",
    svc_transport_text: "Complete handling of deliveries for furniture, kitchens and bulky goods — with precise planning and high daily capacity.",
    svc_montage: "Professional Assembly",
    svc_montage_text: "Furniture and kitchen assembly by specialized teams — with a focus on quality, punctuality and optimal customer experience.",
    svc_showroom: "Showroom Service",
    svc_showroom_text: "Stocking, installation, relocation and refreshing of showroom environments for retail partners and exhibition points.",
    svc_logistik: "Operational Logistics",
    svc_logistik_text: "Coordination of the entire flow from warehouse to end customer — with structured processes and complete transparency.",
    svc_zuegel: "Relocations & Moving",
    svc_zuegel_text: "Professional moving services for private and business customers — careful, punctual and with full insurance coverage.",
    svc_entsorgung: "Disposal",
    svc_entsorgung_text: "Professional disposal of old furniture, kitchens and household items — environmentally friendly, fast and on request directly after delivery.",
    svc_elektro: "Appliances & White Goods",
    svc_elektro_text: "Professional transport and expert installation of all household appliances and white goods — refrigerators, washing machines, dishwashers, stoves — including connection and commissioning.",
    svc_flexschutz: "Fleckenschutz®",
    svc_flexschutz_text: "Professional protection for your new upholstered furniture — impregnation against stains, coffee, water and dirt. 3-year protection guarantee. Learn more →",

    adv_badge: "Why DS Logistik",
    adv_title: "Structure for performance, reliability and trust.",
    adv1_title: "Reliability at industrial scale",
    adv1_text: "Operational structure that handles high daily volume without compromising quality or punctuality.",
    adv2_title: "Speed and precise coordination",
    adv2_text: "Clear planning of routes, teams and installation time windows for maximum efficiency.",
    adv3_title: "Long-term partnership",
    adv3_text: "Business model built for retailers and showrooms seeking consistent standards and shared growth.",
    process_badge: "Workflow",
    process1_title: "Coordination",
    process1_text: "Order planning and detailed coordination with the partner.",
    process2_title: "Transport",
    process2_text: "Safe and monitored transport with the DS Logistik fleet.",
    process3_title: "Assembly",
    process3_text: "Professional assembly at the customer's address or in the showroom.",
    process4_title: "Handover",
    process4_text: "Final quality check and delivery confirmation.",
    partner_badge: "Partner profile",
    partner_title: "Suitable for retail, showrooms and distribution networks.",

    tech_badge: "Technology Partner",
    tech_title: "Optimized with Urbantz",
    tech_desc: "DS Logistik uses Urbantz — the leading last-mile delivery platform — for all route optimizations, real-time tracking and dynamic delivery planning. Every driver, every route, every delivery — digitally managed and optimized.",
    tech_route: "Route Optimization",
    tech_route_text: "Intelligent planning of all 150 vehicles daily",
    tech_track: "Real-time Tracking",
    tech_track_text: "Live location of every driver and delivery",
    tech_48h: "48h Delivery",
    tech_48h_text: "Precise time windows and automatic customer SMS",
    tech_epod: "ePOD & Proof",
    tech_epod_text: "Digital delivery confirmation with photo and signature",

    contact_badge: "Contact & Next Step",
    contact_title: "Ready for operational partnerships? Let's talk.",
    contact_desc: "Contact us directly — by phone, email or fill out the request form. We'll get back to you within 24 hours.",
    form_services_label: "Select services:",
    form_name: "Your name *",
    form_email: "Your e-mail *",
    form_phone: "Phone number (optional)",
    form_message: "Additional information about your request…",
    form_submit: "Send Request",
    contact_phone_label: "Phone",
    contact_addr_label: "Address",
    contact_b2b_label: "B2B Partnerships",
    contact_b2b_text: "Ideal for retail companies, distributors and showroom networks looking for a professional logistics partner.",
    contact_b2c_label: "B2C-Private Customers",
    contact_b2c_text: "Private individuals who want to transport, assemble, move or dispose of furniture — professionally, reliably and at fair prices.",
    form_no_selection: "No selection",
    form_subject_prefix: "Service request:",
    form_body_name: "Name",
    form_body_email: "E-Mail",
    form_body_phone: "Phone",
    form_body_services: "Services",
    form_body_message: "Message",
    form_body_sent: "Sent via DS Logistik website",

    footer_copy: "Transport · Assembly · Showroom",
    footer_since: "Switzerland · Since 2005",
  },

  sq: {
    nav_services: "Shërbime",
    nav_capacity: "Shifra kryesore",
    nav_map: "Rrjeti",
    nav_technology: "Teknologji",
    nav_contact: "Kontakt",
    nav_cta: "Kërkesë",
    navbar_since: "Që nga 2005 · Zvicër",
    navbar_tagline: "Transport · Montim · Showroom",

    hero_badge: "Zgjidhje profesionale · DS Logistik Zvicër",
    hero_title1: "Transport & Montim mobiljesh —",
    hero_title2: "standard industrial",
    hero_title3: ", rezultat premium.",
    hero_desc: "DS Logistik ofron zgjidhje operative të plota për transport mobiljesh, montim kuzhinash, zhvendosje, menaxhim showroom-i dhe logjistikë partnerësh — me 350+ punonjës, 150 automjete, 58+ pika shpërndarjeje dhe 250.000 klientë në vit.",
    hero_btn_contact: "Na kontaktoni tani",
    hero_btn_services: "Shiko shërbimet",
    stats_label: "Kapaciteti operativ",
    stat_mitarbeiter: "Punonjës",
    stat_fahrzeuge: "Automjete 3,5 t",
    stat_kunden: "Klientë / Vit",
    stat_partner: "Partnerë aktivë",
    stat_punkte: "Pika CH",

    video_badge: "DS Logistik · Flota në aksion",
    video_title: "150 automjete. Në aksion çdo ditë. Kudo në Zvicër.",

    stats_badge: "Kompani në shkallë industriale",
    stats_title: "Kapacitet i madh. Ekzekutim i kontrolluar.",
    stats_subtitle: "Shifrat flasin vetë: DS Logistik është strukturuar për të trajtuar vëllimin e lartë të partnerëve retail gjatë gjithë vitit me standarde operative të qëndrueshme.",

    map_badge: "Mbulim i plotë në të gjithë Zvicrën",
    map_title: "58+ pika shpërndarjeje. Çdo kanton. Çdo rajon.",
    map_desc: "Nga Gjeneva në St. Gallen, nga Bazeli në Lugano — rrjeti DS Logistik mbulon të gjithë Zvicrën me kohë shpërndarjeje të shpejtë në të 26 kantonet.",
    map_legend: "Pikë shpërndarjeje DS Logistik",
    map_standorte: "Vendndodhje",
    map_kantone: "Kantone",
    map_lieferzeit: "Koha e dërgimit",

    services_badge: "Oferta jonë e shërbimeve",
    services_title: "Nga depozita te klienti final — zgjidhje operative e plotë.",
    services_desc: "DS Logistik kombinon flotën, ekipet e montimit dhe koordinimin në terren për të ofruar një përvojë të plotë — nga marrja e porosisë deri te dorëzimi i përfunduar.",
    services_coverage: "58+ pika shpërndarjeje në të gjithë Zvicrën",
    services_coverage_text: "Prezencë kombëtare në të gjitha kantonet — për dorëzim të shpejtë dhe të besueshëm në të gjithë Zvicrën.",
    svc_transport: "Transport mobiljesh",
    svc_transport_text: "Menaxhim i plotë i dërgesave për mobilje, kuzhina dhe mallra voluminoze — me planifikim preciz dhe kapacitet të lartë ditor.",
    svc_montage: "Montim profesional",
    svc_montage_text: "Montim mobiljesh dhe kuzhinash nga ekipe të specializuara — me fokus në cilësi, respektim të afateve dhe përvojë optimale të klientit.",
    svc_showroom: "Shërbim Showroom",
    svc_showroom_text: "Furnizim, instalim, zhvendosje dhe rifreskim i ambienteve showroom për partnerët retail.",
    svc_logistik: "Logjistikë operative",
    svc_logistik_text: "Koordinim i të gjithë fluksit nga depozita te klienti final — me procese të strukturuara dhe transparencë të plotë.",
    svc_zuegel: "Zhvendosje",
    svc_zuegel_text: "Shërbime profesionale zhvendosjeje për klientë privatë dhe biznese — me kujdes, në kohë dhe me mbulim të plotë sigurimi.",
    svc_entsorgung: "Heqje e mbeturinave",
    svc_entsorgung_text: "Heqje profesionale e mobiljeve të vjetra, kuzhinave dhe sendeve shtëpiake — ekolojigjisht, shpejt dhe sipas kërkesës direkt pas dorëzimit.",
    svc_elektro: "Pajisje Shtëpiake & Teknikë e Bardhë",
    svc_elektro_text: "Transport profesional dhe instalim i të gjitha pajisjeve shtëpiake dhe teknikës së bardhë — frigorifer, lavatriçe, pjatalarëse, sobë dhe më shumë — direkt te klienti, duke përfshirë lidhjen dhe vënien në funksionim.",
    svc_flexschutz: "Fleckenschutz®",
    svc_flexschutz_text: "Mbrojtje profesionale për mobiljet tuaja të reja të tapicuara — imprenjim kundër njollave, kafesë, ujit dhe dirtit. Garanci mbrojtjeje 3 vjet. Mëso më shumë →",

    adv_badge: "Pse DS Logistik",
    adv_title: "Strukturë për performancë, besueshmëri dhe besim.",
    adv1_title: "Besueshmëri në shkallë industriale",
    adv1_text: "Strukturë operative që menaxhon vëllim të lartë ditor pa kompromentuar cilësinë ose respektimin e afateve.",
    adv2_title: "Shpejtësi dhe koordinim preciz",
    adv2_text: "Planifikim i qartë i rrugëve, ekipeve dhe dritareve kohore të instalimit për ekzekutim sa më efiçient.",
    adv3_title: "Partneritet afatgjatë",
    adv3_text: "Model biznesi i ndërtuar për retailerë dhe showroom-e që kërkojnë standard të qëndrueshëm dhe rritje të përbashkët.",
    process_badge: "Fluksi i punës",
    process1_title: "Koordinim",
    process1_text: "Planifikim porosish dhe koordinim i detajuar me partnerin.",
    process2_title: "Transport",
    process2_text: "Transport i sigurt dhe i mbikëqyrur me flotën DS Logistik.",
    process3_title: "Montim",
    process3_text: "Montim profesional në adresën e klientit ose në showroom.",
    process4_title: "Dorëzim",
    process4_text: "Kontrolli final i cilësisë dhe konfirmimi i dorëzimit.",
    partner_badge: "Profili i partnerit",
    partner_title: "I përshtatshëm për retail, showroom dhe rrjete shpërndarjeje.",

    tech_badge: "Partner teknologjik",
    tech_title: "Optimizuar me Urbantz",
    tech_desc: "DS Logistik përdor Urbantz — platformën lider të last-mile delivery — për të gjitha optimizimet e rrugëve, gjurmimin në kohë reale dhe planifikimin dinamik të dërgesave. Çdo shofer, çdo rrugë, çdo dërgim — menaxhuar dhe optimizuar dixhitalisht.",
    tech_route: "Optimizim rrugësh",
    tech_route_text: "Planifikim inteligjent i të gjitha 150 automjeteve çdo ditë",
    tech_track: "Gjurmim në kohë reale",
    tech_track_text: "Pozicioni live i çdo shoferit dhe dërgese",
    tech_48h: "Dërgesa 48h",
    tech_48h_text: "Dritare kohore precize dhe SMS automatike për klientët",
    tech_epod: "ePOD & Dëshmi",
    tech_epod_text: "Konfirmim dixhital i dërgimit me foto dhe nënshkrim",

    contact_badge: "Kontakt & Hapi tjetër",
    contact_title: "Gati për partneritete operative? Le të flasim.",
    contact_desc: "Na kontaktoni direkt — me telefon, email ose plotësoni formularin e kërkesës. Ju përgjigjemi brenda 24 orëve.",
    form_services_label: "Zgjidhni shërbimet:",
    form_name: "Emri juaj *",
    form_email: "E-mail juaj *",
    form_phone: "Numri i telefonit (opsional)",
    form_message: "Informacion shtesë për kërkesën tuaj…",
    form_submit: "Dërgoni kërkesën",
    contact_phone_label: "Telefon",
    contact_addr_label: "Adresë",
    contact_b2b_label: "Partneritete B2B",
    contact_b2b_text: "Ideal për kompanitë retail, shpërndarës dhe rrjetet e showroom-eve që kërkojnë një partner profesional logjistik.",
    contact_b2c_label: "B2C-Klientë Privatë",
    contact_b2c_text: "Individë privatë që dëshirojnë të transportojnë, montojnë, zhvendosin ose heqin mobilje — me profesionalizëm, besueshmëri dhe çmime të arsyeshme.",
    form_no_selection: "Asnjë zgjedhje",
    form_subject_prefix: "Kërkesë shërbimi:",
    form_body_name: "Emri",
    form_body_email: "E-Mail",
    form_body_phone: "Telefon",
    form_body_services: "Shërbime",
    form_body_message: "Mesazh",
    form_body_sent: "Dërguar përmes faqes DS Logistik",

    footer_copy: "Transport · Montim · Showroom",
    footer_since: "Zvicër · Që nga 2005",
  },
};

export const langNames: Record<Lang, string> = {
  de: "DE",
  fr: "FR",
  it: "IT",
  en: "EN",
  sq: "SQ",
};

export const langFlags: Record<Lang, string> = {
  de: "🇩🇪",
  fr: "🇫🇷",
  it: "🇮🇹",
  en: "🇬🇧",
  sq: "🇦🇱",
};
